import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconStethoscopeComponent } from "./med-icon-stethoscope.component";

@NgModule({
  declarations: [
    MedIconStethoscopeComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconStethoscopeComponent,
  ],
})
export class MedIconStethoscopeModule { }
